import { useParams, Link } from 'react-router-dom';
import CategoryHero, { CategoryPageSEO } from './components/CategoryHero';
import CategoryGrid from './components/CategoryGrid';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <>
      <CategoryPageSEO slug={slug} />
      <main>
        <CategoryHero />
        <CategoryGrid />
      </main>
    </>
  );
}